import React, {useState} from 'react';
import styled from 'styled-components';
import {RecipientField} from './RecipientField';

interface Props {
	to: string[];
	cc: string[];
	bcc: string[];
	onToChange: (values: string[]) => void;
	onCcChange: (values: string[]) => void;
	onBccChange: (values: string[]) => void;
}

const Column = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

const ToRow = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 8px;
`;

const ToField = styled.div`
	flex: 1 1 0%;
`;

const ToggleGroup = styled.div`
	display: flex;
	flex-shrink: 0;
	gap: 4px;
	padding-top: 6px;
`;

const ToggleButton = styled.button`
	border: 0;
	background: transparent;
	padding: 0;
	font: ${p => p.theme.ticketing.font.body3};
	color: #64748b;
	cursor: pointer;
	&:hover {
		color: #334155;
	}
`;

export function RecipientsBar({to, cc, bcc, onToChange, onCcChange, onBccChange}: Props) {
	const [showCc, setShowCc] = useState(cc.length > 0);
	const [showBcc, setShowBcc] = useState(bcc.length > 0);

	return (
		<Column>
			<ToRow>
				<ToField>
					<RecipientField label="To" values={to} onChange={onToChange} />
				</ToField>
				<ToggleGroup>
					{!showCc && (
						<ToggleButton type="button" onClick={() => setShowCc(true)}>
							Cc
						</ToggleButton>
					)}
					{!showBcc && (
						<ToggleButton type="button" onClick={() => setShowBcc(true)}>
							Bcc
						</ToggleButton>
					)}
				</ToggleGroup>
			</ToRow>
			{showCc && <RecipientField label="Cc" values={cc} onChange={onCcChange} />}
			{showBcc && <RecipientField label="Bcc" values={bcc} onChange={onBccChange} />}
		</Column>
	);
}
